var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputersLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "62px",
    viewBox: "0 0 70 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "computers icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EID---IT-Shop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ITShop---Guided-Shop---2---Computers,-Credetials-&-Applications",
    transform: "translate(-447.000000, -563.000000)",
    stroke: "#D2D2D9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Computers",
    transform: "translate(357.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computers-icon",
    transform: "translate(91.093750, 60.468750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0748269,59.0625 L27.7539908,59.0625 C26.4297943,59.0625 25.1508528,59.0625 23.9171662,59.0625 C22.0666365,59.0625 21.7368527,58.4375857 22.3161121,56.2771929 C22.8953714,54.1168001 26.6416163,38.6958385 27.1978036,37.078409 C27.7539908,35.4609796 28.6677991,35.4550658 30.3124865,35.4578119 C31.9571739,35.4609796 34.4930251,35.4578119 36.0656268,35.4578119 C37.6382284,35.4578119 38.3862835,35.424567 38.3862835,38.0078231 C38.3862835,40.5910791 38.3862835,56.5437988 38.3862835,58.1249297",
    id: "Path-11",
    fill: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3702963,47.2797465 C44.2658735,47.2797465 60.8613978,47.260156 63.9882086,47.260156 C67.1150193,47.260156 68.4958725,45.9380095 67.4864443,41.5082093 C66.4770161,37.078409 60.6364608,5.55411096 60.1434583,2.95385475 C59.6504558,0.35359854 57.2025459,0.0139894448 55.4026777,0.0139894448 C53.6028096,0.0139894448 6.82743076,0.0139894448 4.87698495,0.0139894448 C2.92653913,0.0139894448 -0.789941304,-0.471992424 0.149589115,4.28479367 C1.08911953,9.04157976 6.73279128,40.4797319 7.55363418,43.6186107 C8.37447709,46.7574895 10.161554,47.2797465 11.5983268,47.2797465 C13.0350997,47.2797465 22.5712516,47.2797465 24.5204951,47.2797465",
    id: "Path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0748269,32.3470351 L51.1908687,37.894166 M55.9340464,32.3470351 L57.0500882,37.894166",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputersLarge);
export default __webpack_public_path__ + "static/media/computers-large.886c583fc56fcd2f276ef51941a8bf1f.svg";
export { ForwardRef as ReactComponent };